import { t } from "@lingui/core/macro";
import { useNavigation } from "@react-navigation/native";
import graphql from "babel-plugin-relay/macro";
import { Suspense, useEffect } from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { PreloadedQuery, usePreloadedQuery, useQueryLoader } from "react-relay";

import { PackagesList } from "@/features/Packages/PackagesList";
import { Container } from "@whoosh/design-system/src/apps/PatronApp/layout/Container";
import { ScreenHeader } from "@whoosh/design-system/src/apps/PatronApp/layout/ScreenHeader";
import { Button } from "@whoosh/design-system/src/components/controls";
import { Loader } from "@whoosh/design-system/src/components/display";
import { ArrowLeftIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  ScrollView,
} from "@whoosh/design-system/src/components/primitive";

import { PackageListScreenQuery } from "./__generated__/PackageListScreenQuery.graphql";

export const PackageListScreen = () => {
  const [queryRef, loadQuery] = useQueryLoader<PackageListScreenQuery>(
    PackageListScreenQueryString
  );

  useEffect(() => {
    loadQuery(
      { packageType: "STANDARD" },
      { fetchPolicy: "store-and-network" }
    );
  }, [loadQuery]);
  const insets = useSafeAreaInsets();

  return (
    <Box
      bg="surface-primary"
      flex={1}
      style={{ paddingTop: insets.top, paddingBottom: insets.bottom }}
    >
      <Suspense fallback={<Loader />}>
        {queryRef ? <PackageListScreenInner queryRef={queryRef} /> : null}
      </Suspense>
    </Box>
  );
};

type InnerProps = {
  queryRef: PreloadedQuery<PackageListScreenQuery>;
};
const PackageListScreenInner = ({ queryRef }: InnerProps) => {
  const data = usePreloadedQuery(PackageListScreenQueryString, queryRef);
  const navigation = useNavigation();

  const clubName = data.session?.currentClientProfile?.member?.club?.name;

  const onBackPress = () => {
    navigation.goBack();
  };
  return (
    <Container flex={1} paddingHorizontal={0}>
      <ScreenHeader
        title={t`Packages`}
        subHeading={clubName}
        leftItem={
          <Button
            variant="secondary"
            accessibilityLabel={t`Back Button`}
            leftIcon={<ArrowLeftIcon />}
            onPress={onBackPress}
            testID="mobile-header-back-button"
          />
        }
        testID="membership-screen-header"
      />
      <ScrollView pt={4}>
        <PackagesList
          type="STANDARD"
          customerRef={data.session?.currentClientProfile?.member}
        />
      </ScrollView>
    </Container>
  );
};
const PackageListScreenQueryString = graphql`
  query PackageListScreenQuery($packageType: PackageType!) {
    session {
      currentClientProfile {
        member {
          club {
            name
          }
          ... on Customer {
            ...PackagesList_customer
            allPackages: memberPackages(type: $packageType) {
              count
            }
          }
        }
      }
    }
  }
`;
